import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../i18n/LanguageContext'

export default function Navbar() {
  const [isExpanded, setIsExpanded] = useState(false);
  const { content, toggleLang } = useLanguage();
  const { nav } = content.ui;

  function handleToggle(){
      setIsExpanded(!isExpanded);
  }

  const languageButton = (
    <button onClick={toggleLang} className="border border-white/60 rounded-full px-4 py-1 text-base hover:bg-white/20 transition-colors">
      {nav.switchLanguage}
    </button>
  );

  return (
    <nav className="bg-gradient-to-r from-primary to-primaryLight py-3 mb-6 xl:text-xl text-lg shadow-md">
        <ul className="md:flex md:flex-row hidden md:visible justify-center items-center lg:gap-20 gap-12 font-semibold space-around text-white">
            <li><Link to="/"><img src="/new-logo-2.png" alt={nav.home} className="h-14 w-14 bg-white rounded-full p-1"/></Link></li>
            <li><Link to="/course-details" className="hover:text-secondary transition-colors">{nav.courseDetails}</Link></li>
            <li><a href="/#reviews" className="hover:text-secondary transition-colors">{nav.reviews}</a></li>
            <li><Link to="/admission" className="hover:text-secondary transition-colors">{nav.admission}</Link></li>
            <li><Link to="/teachers-panel" className="hover:text-secondary transition-colors">{nav.teachersPanel}</Link></li>
            <li><Link to="/donation" className="hover:text-secondary transition-colors">{nav.donation}</Link></li>
            <li>{languageButton}</li>
        </ul>
        {!isExpanded && (
          <div className="md:hidden flex justify-between items-center px-4 text-white font-semibold">
            <Link to="/"><img src="/new-logo-2.png" alt={nav.home} className="h-10 w-10 bg-white rounded-full p-1"/></Link>
            <div className="flex items-center gap-4">
              {languageButton}
              <img onClick={handleToggle} className="cursor-pointer invert" src="/menu_icon.svg" alt={nav.menu}/>
            </div>
        </div>
        )}
        {isExpanded === true && (
          <ul className="md:hidden flex flex-col justify-center items-center gap-4 font-semibold space-around text-white">
            <img onClick={handleToggle} className="mr-8 ml-auto cursor-pointer invert" src="/menu_icon.svg" alt={nav.menu}/>
            <li><Link to="/"><img src="/new-logo-2.png" alt={nav.home} className="h-12 w-12 bg-white rounded-full p-1"/></Link></li>
            <li className="w-full border-b-[1px] border-b-secondary/30 pb-4"><Link to="/course-details" className="hover:text-secondary">{nav.courseDetails}</Link></li>
            <li className="w-full border-b-[1px] border-b-secondary/30 pb-4"><a href="/#reviews" className="hover:text-secondary">{nav.reviews}</a></li>
            <li className="w-full border-b-[1px] border-b-secondary/30 pb-4"><Link to="/admission" className="hover:text-secondary">{nav.admission}</Link></li>
            <li className="w-full border-b-[1px] border-b-secondary/30 pb-4"><Link to="/teachers-panel" className="hover:text-secondary">{nav.teachersPanel}</Link></li>
            <li className="w-full border-b-[1px] border-b-secondary/30 pb-4"><Link to="/donation" className="hover:text-secondary">{nav.donation}</Link></li>
            <li>{languageButton}</li>
          </ul>
        )}
    </nav>
  )
}
